import React, { useEffect, useState } from "react";
import { useMediaQuery } from "../../../hooks";
import { Spacer } from "../../spacer";
import { MultiPassCardList, PassTabs } from "./multipass_card_list";
import { PortalBookingList } from "./portal_booking_list";
import { Tabs } from "../../../components/tab";
import { Partner } from "../../api";
import { useAnalytics } from "@/lib/analytics/analytics";

const passTabOptions = [
  {
    label: PassTabs.ActivePasses,
    value: PassTabs.ActivePasses,
  },
  {
    label: PassTabs.ExpiredPasses,
    value: PassTabs.ExpiredPasses,
  },
];

interface PortalMultiPassViewProps {
  partner: Partner;
}

export function PortalMultiPassView({ partner }: PortalMultiPassViewProps) {
  const { device } = useMediaQuery();
  const analytics = useAnalytics();

  const [tabValue, setTabValue] = useState(PassTabs.ActivePasses);

  useEffect(() => {
    analytics.event("View Multi Pass Portal", { Source: "Portal" });
  }, [analytics]);

  return (
    <div>
      <Tabs options={passTabOptions} value={tabValue} onChange={setTabValue} />
      <Spacer size={device === "mobile" ? 24 : 32} />
      <MultiPassCardList partner={partner} filterBy={tabValue} />
      <Spacer size={device === "mobile" ? 32 : 40} />
      <PortalBookingList partnerId={partner.id} bookingType="access" />
    </div>
  );
}
